export class BaseSceneEventsController {
  constructor(dispatcher) {
    this.dispatcher = dispatcher;
    this._eventNodes = /* @__PURE__ */ new Set();
    this._requireCanvasEventListeners = false;
    this._actorEventNamesByNode = /* @__PURE__ */ new Map();
    this._actorEventNames = /* @__PURE__ */ new Set();
    this._actorNodesByEventNames = /* @__PURE__ */ new Map();
    this._activeEventDatas = [];
    this._activeEventDataTypes = /* @__PURE__ */ new Set();
  }
  registerEventNode(node) {
    this._eventNodes.add(node);
    this.updateViewerEventListeners();
  }
  unregisterEventNode(node) {
    this._eventNodes.delete(node);
    this.updateViewerEventListeners();
  }
  registerActorNode(node) {
    const eventNames = node.userInputEventNames();
    this._actorEventNamesByNode.set(node, eventNames);
    this._updateActorCache();
    this.updateViewerEventListeners();
  }
  unregisterActorNode(node) {
    this._actorEventNamesByNode.delete(node);
    this._updateActorCache();
    this.updateViewerEventListeners();
  }
  _updateActorCache() {
    this._actorEventNames.clear();
    this._actorNodesByEventNames.clear();
    this._actorEventNamesByNode.forEach((nodeEventNames, node) => {
      for (let eventName of nodeEventNames) {
        this._actorEventNames.add(eventName);
        let setForEventName = this._actorNodesByEventNames.get(eventName);
        if (!setForEventName) {
          setForEventName = /* @__PURE__ */ new Set();
          this._actorNodesByEventNames.set(eventName, setForEventName);
        }
        setForEventName.add(node);
      }
    });
  }
  processEvent(eventContext) {
    var _a;
    if (this._activeEventDatas.length == 0) {
      return;
    }
    const eventType = (_a = eventContext.event) == null ? void 0 : _a.type;
    if (eventType) {
      if (!this._activeEventDataTypes.has(eventType)) {
        return;
      }
    }
    this._eventNodes.forEach((node) => {
      node.processEvent(eventContext);
    });
  }
  updateViewerEventListeners() {
    this._updateActiveEventTypes();
    if (this._requireCanvasEventListeners) {
      this.dispatcher.scene.viewersRegister.traverseViewers((viewer) => {
        viewer.eventsController().updateEvents(this);
      });
    }
  }
  activeEventDatas() {
    return this._activeEventDatas;
  }
  _resetActiveEventData() {
    this._activeEventDatas.splice(0, this._activeEventDatas.length);
    this._activeEventDataTypes.clear();
    const actorEventDatas = this._actorEventDatas();
    if (actorEventDatas) {
      for (let data of actorEventDatas) {
        this._storeEventData(data);
      }
    }
  }
  _actorEventDatas() {
    return void 0;
  }
  _storeEventData(eventData) {
    this._activeEventDatas.push(eventData);
    this._activeEventDataTypes.add(eventData.type);
  }
  _updateActiveEventTypes() {
    this._resetActiveEventData();
    const activeNodeEventTypesState = /* @__PURE__ */ new Set();
    this._eventNodes.forEach((node) => {
      if (node.parent()) {
        const nodeActiveEventDatas = node.activeEventDatas();
        for (let data of nodeActiveEventDatas) {
          activeNodeEventTypesState.add(data);
        }
      }
    });
    activeNodeEventTypesState.forEach((state, data) => {
      this._storeEventData(data);
    });
  }
}
export class BaseSceneEventsControllerClass extends BaseSceneEventsController {
  type() {
    return "";
  }
  acceptedEventTypes() {
    return /* @__PURE__ */ new Set();
  }
}
